import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';

import AccountHeader from '../share/AccountHeader';
import Spinner from '~/components/common/Spinner';
// import ComponyInfomation from '../share/ComponyInfomation';
import ContactInfoFormWrap from '../share/ContactInfoFormWrap';
import ResetPassword from '../share/ResetPassword';
import Button from '~/components/common/Button';
import BillingInfomation from '../share/BillingInfomation';
import mapDispatch from '~/misc/mapDispatch';
import store from '~/store';
import {
  saveAccountInfoAndGetAdminAccountInfo,
  hideAsyncErrorMessage,
} from '~/modules/accountProfilePage/actions';
import {hideChangePasswordAsyncErrorMessage} from '~/modules/user/actions';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {regEmail, regZip, regZipCanada, regPhone, regDot, regMc, regPassWord} from '~/misc/reg';
/* import {getFetchedJSON} from '~/misc/fetch'; */
import { getDotMc } from '~/modules/user/actions'
import {errorInfoConfig} from '~/misc/error-info';
import {changePassword} from '~/modules/user/actions';
import {formatPhone, formatNumberOnly, formatCanadaZip} from '~/misc/formatPhone';
import {track} from '~/misc/metrics';
import VerifyAccount from '../share/VerifyAccount';
import VerifyStatus from '../share/VerifyStatus';
import sharedCSS from '../share.css';
import css from './index.css';
import { getDot, getMc, getName, isActive } from '~/misc/dot'
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
class AccountProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      match: false,
      billingInfoMatch: {},
      formData: {},
      companyInfo: {},
      verifyStatus: {},
      contactInfo: {},
      passwordInfo: {},
      formControl: {},
      needConfirm: false,
    };
    this.handleChangeContactInput = this.handleChangeContactInput.bind(this);
    this.handleToggleComInput = this.handleToggleComInput.bind(this);
    this.synchronousCompanyDataToBil = this.synchronousCompanyDataToBil.bind(this);
    this.handleToggleBillInput = this.handleToggleBillInput.bind(this);
    this.handleContactInputBlur = this.handleContactInputBlur.bind(this);
    this.handleChangeComInput = this.handleChangeComInput.bind(this);
    this.handleChangeBillInput = this.handleChangeBillInput.bind(this);
    this.handleBillInputBlur = this.handleBillInputBlur.bind(this);
    this.initFormValue = this.initFormValue.bind(this);
    this.submitAccountInfo = this.submitAccountInfo.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.handleChangePassWordInput = this.handleChangePassWordInput.bind(this);
    this.handlePassWordInputBlur = this.handlePassWordInputBlur.bind(this);
    this.handleCompInputBlur = this.handleCompInputBlur.bind(this);
    this.handleCompDotMcBlur = this.handleCompDotMcBlur.bind(this);
    this.handleContactDotMcBlur = this.handleContactDotMcBlur.bind(this);
    this.initErrorMessage = this.initErrorMessage.bind(this);
  }

  componentWillMount() {
    track('my account', {'Account profile': 1});
    this.initFormValue();
  }

  componentWillReceiveProps(nextProps) {
    if (
      ((JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user))
      && nextProps.user.isLoggedIn
      && this.props.user.loading
    )) {
      this.initFormValue(nextProps);
    }
  }

  render() {
    const accountInfo = this.props.adminAccountPage.accountInfo.data;
    const profileAccountInfo = this.props.profileAccountInfo;
    const changePasswordErrorMessage = this.props.user.changePasswordErrorMessage
      ? this.props.user.changePasswordErrorMessage
      : null;

    if (isEmpty(accountInfo)) {
      return (
        <div className={sharedCSS.viewH}>
          <div className={sharedCSS.spinnerLine}>
            <div className={sharedCSS.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <AccountHeader
          tit='Account Information'
          titleInfo='Please complete and edit your account information.
          The more information you provide the better your chance of getting business.'
        />
        <VerifyStatus/>
        <VerifyAccount />
        <div className={css.tit}>1、 Contact Information
          {this.props.dots.mainSwitch.data.email_switch.switch
              && !this.props.user.infoIsComplete
              && (<span className={css.updateInfo}>
                Update your Account Info to validate your account.
              </span>)
            }
        </div>
        <ContactInfoFormWrap
          contactInfo={this.state.contactInfo}
          verifyStatus={this.state.verifyStatus}
          dotModStatus={this.state.needConfirm}
          errorControl={this.state.formControl}
          dotUneditable= {this.props.dotUneditable}
          handleChange={this.handleChangeContactInput}
          handleBlur={this.handleContactInputBlur}
          handleDotMcBlur={this.handleContactDotMcBlur}
        />

        {/* <div className={cs(sharedCSS.subtitle, css.clearB)}>2、 Company Information</div> */}
        {/* <ComponyInfomation
          companyInfo={this.state.companyInfo}
          errorControl={this.state.formControl}
          handleToggle={this.handleToggleComInput}
          handleChange={this.handleChangeComInput}
          handleBlur={this.handleCompInputBlur}
          handleDotMcBlur={this.handleCompDotMcBlur}
        /> */}

        <div className={css.titWrap}>
          <div className={cs(sharedCSS.subtitle)}>2、 Billing Information</div>
          {/* <div onClick={this.synchronousCompanyDataToBil}>
            {this.state.match
              ? (<div className={cs(css.checkInput, css.piaochecked, css.on_check)} />)
              : (<div className={css.checkInput} />)
            }
            Use Company & Account Info
          </div> */}
        </div>
        <BillingInfomation
          billingInfo={this.state.billingInfoMatch}
          errorControl={this.state.formControl}
          handleToggle={this.handleToggleBillInput}
          handleChange={this.handleChangeBillInput}
          handleBlur={this.handleBillInputBlur}
        />

        <div className={css.btnWrap}>
          {profileAccountInfo && profileAccountInfo.error && (
            <div className={css.errorTipsWrap}>
              {hideErrorMsg('profileAccountInfo', profileAccountInfo, hideAsyncErrorMessage)}
            </div>
          )}
          <Button className={cs(css.wide)} onClick={this.initFormValue} mods={['large']}>Cancel</Button>
          <Button
            onClick={this.submitAccountInfo}
            className={cs(css.marginLef, css.wide)}
            mods={['large', 'action']}
          >Save</Button>
        </div>

        <div className={cs(sharedCSS.subtitle, css.clearB)}>3、 Reset Password</div>
        <ResetPassword
          handleChange={this.handleChangePassWordInput}
          handleBlur={this.handlePassWordInputBlur}
          errorControl={this.state.formControl}
        />
        <div className={css.btnWrap}>
          {changePasswordErrorMessage && (
            <div className={css.errorTipsWrap}>
              {hideErrorMsg(
                'CHANGE_PASSWORD_ASYNG_ERROR_HIDE',
                changePasswordErrorMessage,
                hideChangePasswordAsyncErrorMessage
              )}
            </div>
          )}
          <Button
            onClick={this.changePassword}
            className={cs(css.marginLef, css.wide)}
            mods={['large', 'action']}
          >Save</Button>
        </div>
      </div>
    );
  }

  initFormValue(param) {
    const info = param ? param.adminAccountPage.accountInfo.data : this.props.adminAccountPage.accountInfo.data;
    const user = param ? param.user : this.props.user;
    const contactData = {
      basicFirstName: user.firstName || '',
      basicLastName: user.lastName || '',
      basicPhone: formatPhone(user.phone) || '',
      basicCompany: info.basicCompany || user.company || '',
      basicDot: info.basicDot || user.dot || '',
      basicMc: info.basicMc || user.mc || '',
      basicIdentity: user.identity || '',
    };

    if(!contactData.basicDot.length) {
      this.setState({
        needConfirm: true
      })
    }else {
      this.setState({
        needConfirm: false
      })
    }

    const verifyStatus = { 
      isPhoneCheck : user.verified_phone,
      isDotLink: 
        (()=>{
          const {linkedStatus: status, w9formStatus: w9status} = user.profileVerificate;
          if(w9status === "Verified") {
            return "Linked";
          }
          if(status === "Unlinked" && w9status === "Pending") {
            return w9status
          }
          return status;
        })(),
    }

    // const companyData = {
    //   companyDot: info.companyDot || user.dot || '',
    //   companyMc: info.companyMc || user.mc || '',
    //   companyAddress: info.companyAddress || '',
    //   companyCity: info.companyCity || '',
    //   companyCountry: info.companyCountry || 'United States',
    //   companyName: info.companyName || '',
    //   companyState: info.companyState || '',
    //   companyZip: info.companyZip || '',
    // };

    info.billCountry = info.billCountry ? info.billCountry : 'United States';

    const billData = this.initBillInfo(info);

    if (!isEmpty(info)) {
      this.setState({
        match: false,
        formData: Object.assign({}, info),
        // companyInfo: companyData,
        contactInfo: contactData,
        verifyStatus,
        billingInfoMatch: billData,
        formControl: Object.assign(
          this.state.formControl,
          this.initErrorMessage(contactData),
          // this.initErrorMessage(companyData),
          this.initErrorMessage(billData)),
      });
    }
  }

  initBillInfo(val) {
    return {
      billFirstname: val.billFirstname || '',
      billLastname: val.billLastname || '',
      billAddress: val.billAddress || '',
      billCity: val.billCity || '',
      billState: val.billState || '',
      billCountry: val.billCountry,
      billZip: val.billZip || '',
      billEmail: val.billEmail || '',
      billPhone: formatPhone(val.billPhone) || '',
    };
  }

  setCompInfoToBill(val) {
    return {
      billFirstname: val.basicFirstName || '',
      billLastname: val.basicLastName || '',
      billAddress: val.companyAddress || '',
      billCity: val.companyCity || '',
      billState: val.companyState || '',
      billCountry: val.companyCountry,
      billZip: val.companyZip || '',
      billEmail: val.basicEmail || '',
      billPhone: formatPhone(val.basicPhone) || '',
    };
  }

  setContactInfoToBill(val) {
    const user = this.props.user;
    return {
      billFirstname: val.basicFirstName || '',
      billLastname: val.basicLastName || '',
      billEmail: user.email || '',
      billPhone: formatPhone(val.basicPhone) || '',
    };
  }

  initErrorMessage(info) {
    let emptyValue = {};

    Object.keys(info).forEach((key) => {
      if (info[key]) {
        emptyValue[key] = {
          error: '',
          onClick: true,
        };
      } else if (key === 'basicMc') {
        emptyValue[key] = {
          error: '',
          onClick: false,
        };
      } else if (key === 'basicCompany') {
        ;;
      } else {
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
      }

      if (key === 'basicPhone'
        && !regPhone.test(formatPhone(info['basicPhone']))
        // && this.props.dots.mainSwitch.data.email_switch.switch
        // && !this.props.user.verified_phone
      ) {
        emptyValue.basicPhone = {
          error: errorInfoConfig.phone.wrong,
          onClick: false,
        };
      }
      if (key === 'basicDot' &&
        this.props.user.profileVerificate.linkedStatus === "Invalidate"
      ) {
        emptyValue.basicDot = {
          error: errorInfoConfig.dot.wrong,
          onClick: false,
        };
      }

      // if (key === 'basicMc' &&
      //   this.props.dots.mainSwitch.data.email_switch.switch &&
      //   !this.props.user.mc_verified
      // ) {
      //   emptyValue.basicMc = {
      //     error: errorInfoConfig.mc.wrong,
      //     onClick: false,
      //   };
      // }

      if (key === 'companyDot'
        && this.props.dots.mainSwitch.data.email_switch.switch
        && !this.props.user.verify_result
        && info[key]
      ) {
        emptyValue.companyDot = {
          error: errorInfoConfig.dot.wrong,
          onClick: false,
        };
      }

      if (key === 'companyMc'
        && this.props.dots.mainSwitch.data.email_switch.switch
        && !this.props.user.verify_result
        && info[key]
        && !info.companyDot
      ) {
        emptyValue.companyMc = {
          error: errorInfoConfig.mc.wrong,
          onClick: false,
        };
      }
    });
    return emptyValue;
  }

  synchronousCompanyDataToBil() {
    const synchronousInfo = this.setContactInfoToBill(this.state.formData);
    const restoreInfo = this.initBillInfo(this.props.adminAccountPage.accountInfo.data);

    if (!this.state.match) {
      return this.setState({
        match: true,
        billingInfoMatch: synchronousInfo,
        formControl: Object.assign({}, this.state.formControl, this.initErrorMessage(synchronousInfo)),
      });
    }

    return this.setState({
      match: false,
      billingInfoMatch: restoreInfo,
      formControl: Object.assign({}, this.state.formControl, this.initErrorMessage(restoreInfo)),
    });
  }

  submitAccountInfo() {
    if (this.props.profileAccountInfo.disable) {
      return false;
    }
    const formData = this.state.formData;
    const data = Object.assign(
      {},
      formData,
      // this.state.companyInfo,
      this.state.billingInfoMatch,
      this.state.contactInfo);

    const connectFormValue = Object.assign(
      {},
      // this.state.companyInfo,
      this.state.billingInfoMatch,
      this.state.contactInfo);

    let emptyValue = {};

    // dot 和 mc  有一项存在即可
    if (connectFormValue.basicDot || connectFormValue.basicMc) {
      delete connectFormValue.basicDot;
      delete connectFormValue.basicMc;
    } else {
      delete connectFormValue.basicMc;
    }

    Object.keys(connectFormValue).forEach((key) => {
      if (!connectFormValue[key] && key !== 'basicMc' && key !== 'basicExt' && key !== 'basicCompany') { // judge empty value except MC
        if (key === 'billEmail') {
          emptyValue[key] = {
            error: errorInfoConfig.email.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'basicDot') {
          emptyValue[key] = {
            error: errorInfoConfig.dot.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'companyZip' || key === 'billZip') {
          emptyValue[key] = {
            error: errorInfoConfig.zip.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'billPhone' || key === 'phone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      } else if (this.state.formControl[key] && this.state.formControl[key].error) {
        emptyValue[key] = this.state.formControl[key];
      }
    });

    if (isEmpty(emptyValue)) {
      // 存储数据前格式化电话号码
      if (data.basicPhone) {data.basicPhone = formatNumberOnly(data.basicPhone);}
      if (data.billPhone) {data.billPhone = formatNumberOnly(data.billPhone);}
      if (data.phone) {data.phone = formatNumberOnly(data.phone);}

      if(this.state.needConfirm) {
        return this.props.dotConfirm({
          confirm: store.dispatch((dispatch, getState) => saveAccountInfoAndGetAdminAccountInfo(dispatch, getState, data)),
          dot: subObj.dot,
          company: subObj.company
        })
        //return this.props.dotConfirm(()=> store.dispatch((dispatch, getState) => saveUserPageContactInfo(dispatch, getState, this.state.formData)));
      }

      return store.dispatch((dispatch, getState) => saveAccountInfoAndGetAdminAccountInfo(dispatch, getState, data));
    }

    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }

  handleChangeComInput(e) {
    return this.setState({
      companyInfo: {
        ...this.state.companyInfo,
        [e.target.name]: e.target.value,
      },
    });
  }

  handleChangeContactInput(e) {
    return this.setState({
      contactInfo: {
        ...this.state.contactInfo,
        [e.target.name]: e.target.value,
      },
    });
  }
  handleChangePassWordInput(e) {
    return this.setState({
      passwordInfo: {
        ...this.state.passwordInfo,
        [e.target.name]: e.target.value,
      },
    });
  }

  handleChangeBillInput(e) {
    return this.setState({
      billingInfoMatch: {
        ...this.state.billingInfoMatch,
        [e.target.name]: e.target.value,
      },
    });
  }

  processDataAndSetState(stateType, typeName, errorTips, inputVal, clickType) {
    return this.setState({
      [stateType]: {
        ...this.state[stateType],
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }

  regData(stateType, inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) {
    if (!inputVal) {
      return this.processDataAndSetState(stateType, typeName, emptyErrorTips, inputVal, false);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(stateType, typeName, wrongErrorTips, inputVal, false);
    }
    return this.processDataAndSetState(stateType, typeName, '', inputVal, true);
  }

  handleBlur(stateType, e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'password': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.password.empty,
          errorInfoConfig.password.wrong,
          regPassWord,
          name
        );
      }
      case 'text': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.text.empty,
          errorInfoConfig.text.wrong,
          false,
          name
        );
      }
      case 'zip': {
        // 美国的zip格式
        if (
          (name.includes('company')
            && this.state[stateType].companyCountry
            && this.state[stateType].companyCountry === 'United States')
          || (name.includes('bill')
            && this.state[stateType].billCountry
            && this.state[stateType].billCountry === 'United States')
        ) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 5),
            errorInfoConfig.zip.empty,
            errorInfoConfig.zip.wrong,
            regZip,
            name
          );
        }

        // 加拿大的zip格式
        return this.regData(
          stateType,
          formatCanadaZip(inputVal),
          errorInfoConfig.zip.empty,
          errorInfoConfig.zip.wrong,
          regZipCanada,
          name
        );
      }
      case 'email': {
        return this.regData(
          stateType,
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name
        );
      }
      case 'phone': {
        return this.regData(
          stateType,
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name
        );
      }
      case 'notNeed': {
        return this.regData(
          stateType,
          inputVal,
          '',
          '',
          false,
          name
        );
      }
      case 'dot': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 7),
          '',
          errorInfoConfig.dot.wrong,
          regDot,
          name);
      }
      case 'mc': {
        return this.regData(
          stateType,
          formatNumberOnly(inputVal, 6),
          '',
          errorInfoConfig.mc.wrong,
          regMc,
          name);
      }
    }
    return null;
  }

  blurDotMc(stateType, e) {
    const { getDotMc } = this.props;

    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);

    switch (type) {
      case 'dot': {
        if (!regDot.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 7),
            '',
            errorInfoConfig.dot.wrong,
            regDot,
            name);
        }
        // TODO: new dot portzl
        return getDotMc({dot: inputVal})
          .then(res => {
            const data = {
              companyDot: inputVal,
              companyMc: getMc(res.data),
              companyName: getName(res.data),
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'basicDot'
            );
            this.regData(
              stateType,
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'basicCompany'
            );
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'basicMc'
            );
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.dot.wrong, inputVal, true);
          });
      }
      case 'mc': {
        if (!regMc.test(inputVal)) {
          return this.regData(
            stateType,
            formatNumberOnly(inputVal, 6),
            '',
            errorInfoConfig.mc.wrong,
            regMc,
            'basicMc');
        }

        return getDotMc({mc: inputVal})
          .then(res => {
            const data = {
              companyDot: getDot(res.data),
              companyMc: inputVal,
              companyName: getName(res.data),
            };
            this.regData(
              stateType,
              data.companyDot,
              '',
              '',
              false,
              'basicDot'
            );
            this.regData(
              stateType,
              data.companyName,
              errorInfoConfig.text.empty,
              errorInfoConfig.text.wrong,
              false,
              'basicCompany'
            );
            this.regData(
              stateType,
              data.companyMc,
              '',
              '',
              false,
              'basicMc'
            );
          })
          .catch(() => {
            this.processDataAndSetState(stateType, name, errorInfoConfig.mc.wrong, inputVal, true);
          });
      }
    }
    return null;
  }

  handleToggle(stateType, e) {
    if (this.state[stateType][e.currentTarget.getAttribute('data-name')] === e.currentTarget.textContent) {
      return null;
    }

    this.processDataAndSetState(
      stateType,
      e.currentTarget.getAttribute('data-name'),
      '',
      e.currentTarget.textContent,
      true);

    // 如果toggle的是country init state 和zip 值
    if (e.currentTarget.getAttribute('data-name') === 'billCountry') {
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'billState', errorInfoConfig.text.empty, '', false);
      }, 0);
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'billZip', errorInfoConfig.text.empty, '', false);
      }, 0);
    }
    if (e.currentTarget.getAttribute('data-name') === 'companyCountry') {
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'companyState', errorInfoConfig.text.empty, '', false);
      }, 0);
      setTimeout(() => {
        this.processDataAndSetState(stateType, 'companyZip', errorInfoConfig.text.empty, '', false);
      }, 0);
    }
    return null;
  }

  handleCompInputBlur(e) {
    this.handleBlur('companyInfo', e);
  }
  handleContactInputBlur(e) {
    this.handleBlur('contactInfo', e);
  }
  handlePassWordInputBlur(e) {
    this.handleBlur('passwordInfo', e);
  }
  handleBillInputBlur(e) {
    this.handleBlur('billingInfoMatch', e);
  }
  handleContactDotMcBlur(e) {
    this.blurDotMc('contactInfo', e);
  }
  handleCompDotMcBlur(e) {
    this.blurDotMc('companyInfo', e);
  }
  handleToggleBillInput(e) {
    this.handleToggle('billingInfoMatch', e);
  }
  handleToggleComInput(e) {
    this.handleToggle('companyInfo', e);
  }

  filterEmptyInputVal(formData) {
    let emptyValue = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        if (key === 'old_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'new_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'confirm_password') {
          emptyValue[key] = {
            error: errorInfoConfig.password.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      }
    });
    return emptyValue;
  }

  canClickOrNot(formControl) {
    let emptyValue = [];
    Object.keys(formControl).forEach((key, index) => {
      if (key !== 'companyMc') {
        if (formControl[key].onClick) {
          emptyValue[index] = true;
          return;
        } else if (formControl[key].onClick === false) {
          emptyValue[index] = false;
          return;
        }
      }
    });

    if (!includes(emptyValue.toString(), 'false')) {
      return true;
    }
    return false;
  }

  changePassword() {
    track('my account', {'Account profile – change password': 1});
    const formData = this.state.passwordInfo;
    const passwordFromData = {
      old_password: formData.old_password || '',
      new_password: formData.new_password || '',
      confirm_password: formData.confirm_password || '',
    };

    let emptyValue = this.filterEmptyInputVal(passwordFromData);


    if (isEmpty(emptyValue) && this.canClickOrNot(emptyValue)) {
      if (passwordFromData.new_password !== passwordFromData.confirm_password) {
        return this.setState({
          formControl: Object.assign(emptyValue,
            {
              confirm_password: {
                error: errorInfoConfig.password.confirm,
                onClick: false,
              },
            }),
        });
      }
      return store.dispatch((dispatch, getState) => changePassword(dispatch, getState, passwordFromData));
    }
    const controlData = Object.assign(this.state.formControl, emptyValue);
    return this.setState({
      formControl: controlData,
    });
  }
}

export default connect(({accountProfilePage, user, dots}) => ({
  profileAccountInfo: accountProfilePage.profileAccountInfo,
  user,
  dots,
}), mapDispatch({
  getDotMc: (props, {dot, mc}) => getDotMc({dot, mc}),
  dotConfirm: (props, {confirm, dot, company}) => modalChange(modes.DOT_CONFIRM,  {type: 'askPop', confirm, dot, company}),
  dotUneditable: (props, data) => modalChange(modes.DOT_UNEDITABLE,  {type: 'askPop'}),
}))(AccountProfile);





// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/AccountProfile/index.js